import React from "react";
import { Container, Typography, Paper, Box } from "@mui/material";
import ConstructionIcon from "@mui/icons-material/Construction";

const Sales = () => {
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Paper
        elevation={3}
        sx={{
          p: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "60vh",
          textAlign: "center",
        }}
      >
        <ConstructionIcon
          sx={{
            fontSize: 80,
            color: "text.secondary",
            mb: 3,
          }}
        />
        <Typography variant="h4" gutterBottom color="text.primary">
          Модуль "Продажи"
        </Typography>
        <Typography variant="h6" color="text.secondary" gutterBottom>
          В разработке
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>
          Данный модуль находится в стадии разработки и будет доступен в ближайшем обновлении.
        </Typography>
        <Box sx={{ mt: 3 }}>
          <Typography variant="body2" color="text.secondary">
            Здесь будут размещены функции для управления продажами:
          </Typography>
          <Box component="ul" sx={{ mt: 1, textAlign: "left" }}>
            <Typography component="li" variant="body2" color="text.secondary">
              Создание и редактирование сделок продаж
            </Typography>
            <Typography component="li" variant="body2" color="text.secondary">
              Управление воронкой продаж
            </Typography>
            <Typography component="li" variant="body2" color="text.secondary">
              Отчеты по продажам
            </Typography>
            <Typography component="li" variant="body2" color="text.secondary">
              Интеграция с CRM-системой
            </Typography>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default Sales;
